<template>
  <div class="tw-inline-block">
    <IconButton
      icon="pen"
      color="outline-secondary"
      @click="openModal(EDIT_BIOGRAPHY_MODAL_NAME)"
      test_id="bio-edit"
    >
      <PenIcon />
    </IconButton>

    <FormModal
      header="Bio"
      description="You can talk about your years of experience, industry, or skills. People also talk about their achievements or previous job experience."
      :name="EDIT_BIOGRAPHY_MODAL_NAME"
    >
      <FormModalBody
        footer-button-text="Save"
        :is-button-loading="form.processing"
        @submit="saveForm"
      >
        <FormInput
          v-model="form.about_me"
          :is-error="Boolean(form.errors.about_me)"
          :errors="form.errors.about_me"
          @input="form.clearErrors('about_me')"
          as="textarea"
          rows="8"
          is-required
          :max-characters="300"
        >
          <template #label>Add summary</template>
          <template #caption>Displayed within search</template>
        </FormInput>
        <FormInput
          v-model="form.extended_summary"
          :is-error="Boolean(form.errors.extended_summary)"
          :errors="form.errors.extended_summary"
          @input="form.clearErrors('extended_summary')"
          class="tw-mt-4"
          as="textarea"
          rows="8"
          is-required
          test_id="bio-extended-summary-input"
        >
          <template #label>Extended summary</template>
          <template #caption>Displayed in profile description</template>
        </FormInput>
        <FormInput
          v-model="form.video_url"
          :is-error="Boolean(form.errors.video_url)"
          :errors="form.errors.video_url"
          @input="form.clearErrors('video_url')"
          class="tw-mt-4"
          type="text"
          placeholder="Insert the link URL here..."
        >
          <template #label>
            Youtube intro video URL
            <span class="tw-ml-1 tw-text-sm tw-font-normal tw-text-neutral-400">
              (optional)
            </span>
          </template>
          <template #caption>
            <div>Embedded Youtube video displayed on your profile page.</div>
            <div>
              Please take some time to read the
              <a
                class="tw-link"
                href="https://www.growthmentor.com/faq/youtube-introduction-videos/"
              >
                Video Introduction Requirements
              </a>
              before you upload your video.
            </div>
          </template>
        </FormInput>
      </FormModalBody>
    </FormModal>
  </div>
</template>

<script setup>
import IconButton from '@/shared/components/IconButton.vue'
import FormModal from '@/shared/components/modals/FormModal/FormModal.vue'
import FormModalBody from '@/shared/components/modals/FormModal/FormModalBody.vue'
import FormInput from '@/shared/components/forms/FormInput.vue'
import PenIcon from '@/assets/images/icons/pen.svg'
import { EDIT_BIOGRAPHY_MODAL_NAME } from '@/shared/data/globalVariables.js'
import { useForm } from '@inertiajs/vue3'
import { useModals } from '@/shared/composables/useModals.js'

const props = defineProps({
  biography: {
    type: String,
    default: '',
  },
  video: {
    type: String,
    default: '',
  },
  aboutMe: {
    type: String,
    default: '',
  },
})

const { openModal, closeModal } = useModals()

const form = useForm({
  about_me: props.aboutMe,
  extended_summary: props.biography,
  video_url: props.video,
})

const saveForm = () => {
  form
    .transform((data) => ({
      mentor: data,
    }))
    .patch('/profile/mentor/biographies', {
      preserveScroll: true,
      onSuccess: () => {
        closeModal(EDIT_BIOGRAPHY_MODAL_NAME)
      },
    })
}
</script>
